import styled from 'styled-components';

import theme from '../../../config/theme';

const Text = styled.div`
  font-size: ${theme.fonts.sizes.l};
`;

export default Text;
